import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { useState } from "react";
import { Button, Form, Image, Toast } from "react-bootstrap";
import {
  LoaderWrapper,
  FieldDropSide,
  UploadComponent,
  SearchableList,
} from "../../../components";
import {
  createRule,
  createSettings,
  generateOutputProfile,
  post,
} from "../../../services/mappingTemplates";
import Cancel from "../../../styles/cancel.png";
import { required } from "../../../utils";

export const options = [
  { label: "Output", value: 1 },
  { label: "Pass Thorugh Setting", value: 2 },
  { label: "Pass Thorugh Mapping", value: 3 },
  { label: "Pass Thorugh Rules", value: 4 },
];

const MappingTemplateContainer = (props) => {
  const [showToast, setShowToast] = useState(false);
  const [showError, setShowError] = useState(false);
  const [fileUploadRequired, setFileUploadRequired] = useState("");

  const onFormSubmit = (values, { setFieldError }) => {
    var data = new FormData();
    var file = values["file"];
    if (!file) {
      setFileUploadRequired("Required");
      return;
    } else {
      setFileUploadRequired("");
    }

    data.append("file", file[0]);
    if (values.mappingTemplate == 1) {
      generateOutputProfile(data)
        .then((response) => {
          setShowToast(true);
        })
        .catch((e) => {
          setShowError(true);
        });
    } else if (values.mappingTemplate == 2) {
      createSettings(data)
        .then((response) => {
          setShowToast(true);
        })
        .catch((e) => {
          setShowError(true);
        });
    } else if (values.mappingTemplate == 3) {
      post(data)
        .then((response) => {
          setShowToast(true);
        })
        .catch((e) => {
          setShowError(true);
        });
    } else if (values.mappingTemplate == 4) {
      createRule(data)
        .then((response) => {
          setShowToast(true);
        })
        .catch((e) => {
          setShowError(true);
        });
    }
  };

  return (
    <Formik
      //validationSchema={validationSchema}
      initialValues={{}}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setFieldError,
        values,
        errors,
        touched,
        ...rest
      }) => {
        return (
          <Form
            className="mb-20 h-100"
            onSubmit={handleSubmit}
            //validated={!isEmpty(rest.errors)}
          >
            <LoaderWrapper isLoading={false}>
              <div
                style={{ padding: "15px", borderBottom: "1px solid #BDBDBD" }}
                className="ft-20 fw-500 marg-bot-20"
              >
                Upload a Mapping Template
              </div>

              <div
                style={{ padding: "15px" }}
                className="d-flex flex-column align-items-center"
              >
                <Field
                  size="smd"
                  isRequired
                  label="Mapping Template"
                  name={"mappingTemplate"}
                  value={values["mappingTemplate"]}
                  disabled={false}
                  options={options}
                  popupContent={
                    <SearchableList
                      //isNotTypeAhead
                      label="Select a level"
                      name={"mappingTemplate"}
                      //selectedValue={values[fields.level]}
                      onSelect={(e) => {
                        //setValues({ ...values, [fields.level]: e });
                        setFieldValue("mappingTemplate", e);
                      }}
                      options={options}
                      disabled={false}
                    />
                  }
                  component={FieldDropSide}
                  validate={required}
                />
                <UploadComponent
                  name="file"
                  setFieldValue={setFieldValue}
                  fileExtensions=".csv"
                  setFileUploadRequired={setFileUploadRequired}
                />
                <p
                  style={{
                    fontSize: "0.75rem",
                    marginTop: "0rem",
                    color: "#ff5050",
                  }}
                >
                  {fileUploadRequired}
                </p>
                <div className="disp-flex-row">
                  {/* <Button className="marg-right-10" variant="secondary">Go Back</Button> */}
                  <Button variant="primary" type="submit">
                    Upload
                  </Button>
                </div>
              </div>
              {showError && (
                <div
                  className={`error-banner justify-content-between d-flex align-items-center ${
                    (showError && "enable") || ""
                  }`}
                >
                  <div>
                    <Image src={Cancel} width="30px" />
                  </div>
                  <div>
                    <div className="error-heading">{"Error"}</div>
                    <div className="error-reason">
                      {"Oops! Something went wrong"}
                    </div>
                  </div>
                  <div>
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      color="#000"
                      style={{ fontSize: "14px" }}
                      onClick={() => setShowError(false)}
                    />
                  </div>
                </div>
              )}
              <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                style={{
                  position: "fixed",
                  top: "10rem",
                  right: "2rem",
                  zIndex: "100",
                }}
                delay={3000}
                autohide
              >
                <Toast.Body className="success-toast-align">
                  <div className="mr-2">
                    {showToast ? (
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        color="#3BB54A"
                        size="lg"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div>{"Template Created Successfully"}</div>
                  <div className="ml-2">
                    {showToast ? (
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        color="#000000"
                        size="md"
                        onClick={() => setShowToast(false)}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </Toast.Body>
              </Toast>
            </LoaderWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default MappingTemplateContainer;
